export default {
	btn: 'Vérifier un NIR',
	popup: {
		title: 'Vérifier un NIR'
	},
	form: {
		placeholder: 'Rechercher un patient par NIR',
		label: 'NIR',
		btn: 'Rechercher',
		no_result: 'Aucune correspondance n’a été trouvée, merci de renouveler votre recherche',
		invalid_format: 'Le format du NIR est invalide.'
	},
	headers: {
		fullName: 'Prénom Nom',
		birthDate: 'Date de naissance',
		birthOrder: 'Rang de naissance',
		gender: 'Sexe'
	}
};
